export enum CalendarDatePickerRange {
  Monthly = 'month',
  Weekly = 'week',
  Yearly = 'year',
  Daily = 'day'
}
